import configs from 'shared/providers/analytics/config.json';

export type AnalyticsConfig = {
  screenConfigs: Map<string, EventConfig>;
  pressableConfigs: Map<string, EventConfig>;
  networkConfigs: Map<string, EventConfig>;
};
export type EventConfig = {
  name: string;
  source_name?: string;
  url?: string;
  faq_name?: string;
  category: string;
  subcategory?: string;
};
type NestedEventJsonConfig = {
  config: {
    key: string;
    name: string;
    url?: string;
    faq_name?: string;
    source_name?: string;
    category: string;
    subcategory?: string;
  };
};
type AnalyticsJsonConfig = {
  screenConfigs: Array<NestedEventJsonConfig>;
  pressableConfigs: Array<NestedEventJsonConfig>;
  networkConfigs: Array<NestedEventJsonConfig>;
};
export function initializeAnalyticsConfig(): AnalyticsConfig {
  const config: { configs: AnalyticsJsonConfig } = configs;
  const screenConfigsMap = new Map(
    config.configs.screenConfigs.map(({ config }) => [
      config.key,
      {
        name: config.name,
        source_name: config.source_name,
        category: config.category,
        subcategory: config.subcategory,
      },
    ]),
  );
  const pressableConfigsMap = new Map(
    config.configs.pressableConfigs.map(({ config }) => [
      config.key,
      {
        name: config.name,
        faq_name: config?.faq_name,
        url: config?.url,
        source_name: config.source_name,
        category: config.category,
        subcategory: config.subcategory,
      },
    ]),
  );
  const networkConfigsMap = new Map(
    config.configs.networkConfigs.map(({ config }) => [
      config.key,
      {
        name: config.name,
        faq_name: config?.faq_name,
        url: config?.url,
        source_name: config.source_name,
        category: config.category,
        subcategory: config.subcategory,
      },
    ]),
  );
  return {
    screenConfigs: screenConfigsMap,
    pressableConfigs: pressableConfigsMap,
    networkConfigs: networkConfigsMap,
  };
}
